import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /*
  * 打印模板设置
  * */
  printTemplateList: {},
  printTemplateMark: 0,
  storehouseList: {obj: []}, // 仓点列表
  sysTemplateList: [], // 获取到的系统模板列表
  templateData: [], // 编辑时获取系统数据
  constMark: 0
}

const actions = {
  /*
  * 打印模板设置
  * */
  // 列表
  [types.GETPRINTTEMPLATEPAGE] (context, params) {
    http.fetch('/api/printTemplate/getPrintTemplatePage', params).then(data => {
      context.commit(types.GETPRINTTEMPLATEPAGE, data)
    })
  },
  // 复制
  [types.COPYPRINTTEMPLATE] (context, params) {
    http.fetch('/api/printTemplate/copyPrintTemplate', params).then(data => {
      context.commit(types.COPYPRINTTEMPLATE, data)
    })
  },
  // 设置默认
  [types.SETPRINTTEMPLATEDEF] (context, params) {
    http.fetch('/api/printTemplate/setPrintTemplateDef', params).then(data => {
      context.commit(types.SETPRINTTEMPLATEDEF, data)
    })
  },
  // 删除
  [types.DELETEPRINTTEMPLATE] (context, params) {
    http.fetch('/api/printTemplate/deletePrintTemplate', params).then(data => {
      context.commit(types.DELETEPRINTTEMPLATE, data)
    })
  },
  // 获取仓点列表
  [types.DROPDOWNLIST] (context, params) {
    http.fetch('api/ycDispatchPlatformPoint/dropDownList', params).then(data => {
      context.commit(types.DROPDOWNLIST, data)
    })
  },
  // 获取系统模板
  [types.GETSYSTEMP] (context, params) {
    http.fetch('api/printTemplate/getTemplateList', params).then(data => {
      context.commit(types.GETSYSTEMP, data)
    })
  },
  // 编辑时获取模板数据
  [types.GETTEMPDATA] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('api/printTemplate/getPrintTemplate', params).then(data => {
        if (data.success) {
          resolve(data.obj)
        }
        context.commit(types.GETTEMPDATA, data.obj)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存模板数据
  [types.SAVETEMPDATA] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('api/printTemplate/savePrintTemplate', params).then(data => {
        context.commit(types.SAVETEMPDATA, data)
        if (data.success) {
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}

const mutations = {
  /*
  * 打印模板设置
  * */
  // 列表
  [types.GETPRINTTEMPLATEPAGE] (state, data) {
    state.printTemplateList = data
  },
  // 复制
  [types.COPYPRINTTEMPLATE] (state, data) {
    if (data.success) {
      state.printTemplateMark = 1
      vue.$message({
        showClose: true,
        message: '复制成功',
        type: 'success'
      })
    }
  },
  // 设置默认
  [types.SETPRINTTEMPLATEDEF] (state, data) {
    if (data.success) {
      state.printTemplateMark = 1
      vue.$message({
        showClose: true,
        message: '已设置为默认',
        type: 'success'
      })
    }
  },
  // 删除
  [types.DELETEPRINTTEMPLATE] (state, data) {
    if (data.success) {
      state.printTemplateMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    }
  },
  // 获取仓点列表
  [types.DROPDOWNLIST] (state, data) {
    data.type = Math.random()
    state.storehouseList = data
  },
  // 获取系统模板
  [types.GETSYSTEMP] (state, data) {
    state.sysTemplateList = data.obj
  },
  // 编辑时获取模板数据
  [types.GETTEMPDATA] (state, data) {
    state.templateData = data
  },
  // 保存模板数据
  [types.SAVETEMPDATA] (state, data) {
    if (data.success) {
      state.printTemplateMark = 1
      vue.$message({
        showClose: true,
        message: '保存模板成功',
        type: 'success'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/printTemplate/index.js